import React, { type FC, type PropsWithChildren } from 'react';

import { withImage } from '@lucid/hooks';

import Card, { type CardElementProps } from '../../card/card';
import ImageWithPlaceholder from '../../image/image-with-placeholder';

export interface ProductCardProps extends Omit<CardElementProps, 'children'> {
  /** Allows the component to get additional styles. */
  className?: string;
}

const ProductCard: FC<PropsWithChildren<ProductCardProps>> = ({ className, link, media, text, heading }) => (
  <Card
    shouldAnimateOnHover
    css={theme => ({
      label: 'productCard',
      overflow: 'hidden',
      width: '360px',
      [theme.breakpoints.bp768.min]: { width: '515px' },
    })}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
  >
    {media && (
      <ImageWithPlaceholder
        alt=""
        css={{
          width: 'auto',
          margin: '-24px',
          minHeight: '490px',
          zIndex: 0,
          img: {
            height: '490px',
            objectFit: 'cover',
          },
        }}
        src={withImage(media.image) || ''}
      />
    )}
    {media && <Card.Divider type="fullBleed" />}
    {heading && <Card.Heading as="h3" heading={heading} />}
    {text && <Card.Text {...text} />}
    {link?.final_url && <Card.Link {...link} />}
  </Card>
);

export { ProductCard };
export default ProductCard;
